import { API_URL, RESULT_PER_PAGE, API_KEY } from './config';
import { AJAX } from './helper';
import paginationView from './views/paginationView';

export const state = {
  recipe: {},
  search: {
    query: '',
    result: [],
    page: 1,
    resultPerPage: RESULT_PER_PAGE,
  },
  bookmark: [],
};
function setRecipe(dataFromApi) {
  const { recipe } = dataFromApi.data;
  return (state.recipe = {
    id: recipe.id,
    image: recipe.image_url,
    ingredients: recipe.ingredients,
    publisher: recipe.publisher,
    servings: recipe.servings,
    sourceUrl: recipe.source_url,
    title: recipe.title,
    cookTime: recipe.cooking_time,
    ...{ key: recipe.key ? recipe.key : false },
  });
}

export async function loadRecipe(ID) {
  try {
    const data = await AJAX(`${API_URL}${ID}`);
    const recipe = setRecipe(data);

    if (state.bookmark.some(rec => rec.id === recipe.id))
      state.recipe.bookmarked = true;
  } catch (err) {
    throw err;
  }
}

export async function loadSearchResult(query) {
  try {
    const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);

    if (!data.results) throw new Error('No recipe found with this query.');
    state.search.query = query;
    state.search.result = data.data.recipes.map(recipe => {
      return {
        id: recipe.id,
        image: recipe.image_url,
        publisher: recipe.publisher,
        title: recipe.title,
        ...{ key: recipe.key ? recipe.key : false },
      };
    });
    state.search.page = 1;
  } catch (err) {
    state.search.result = [];
    throw err;
  }
}

export function getSearchResultPage(page = state.search.page) {
  state.search.page = page;
  const start = (page - 1) * state.search.resultPerPage;
  const end = page * state.search.resultPerPage;

  return state.search.result.slice(start, end);
}

export function updateServings(newServings) {
  state.recipe.ingredients.forEach(ing => {
    ing.quantity = (ing.quantity * newServings) / state.recipe.servings;
  });
  state.recipe.servings = newServings;
}

export function addBookmark(recipe) {
  recipe.bookmarked = true;
  state.bookmark.push(recipe);

  syncLocalStorage();
}

export function removeBookmark(id) {
  const index = state.bookmark.findIndex(recipe => recipe.id === id);
  state.bookmark.splice(index, 1);

  if (state.recipe.id === id) state.recipe.bookmarked = false;

  syncLocalStorage();
}

export async function uploadRecipe(formDataArr) {
  try {
    // Get ingredinets
    const ingredients = formDataArr
      .filter(entry => {
        if (entry[0].startsWith('ingredient') && entry[1] !== '') {
          return true;
        }
      })
      .map(function (entry) {
        const ing = entry[1].split(',');
        if (ing.length !== 3)
          throw Error('Ingredients are not in correct format!');
        ing.forEach(e => e.trim());
        const [quantity, unit, description] = ing;

        return { quantity: quantity ? +quantity : '', unit, description };
      });
    const formData = Object.fromEntries(formDataArr);
    const recipe = {
      // id: formData.id,
      image_url: formData.image,
      ingredients,
      publisher: formData.publisher,
      servings: +formData.servings,
      source_url: formData.sourceUrl,
      title: formData.title,
      cooking_time: +formData.cookingTime,
    };

    const res = await AJAX(`${API_URL}?key=${API_KEY}`, recipe);

    setRecipe(res);
  } catch (err) {
    throw err;
  }
}

export function syncLocalStorage() {
  window.localStorage.setItem('bookmark', JSON.stringify(state.bookmark));
}

function init() {
  const bookmarks = JSON.parse(window.localStorage.getItem('bookmark'));
  if (!bookmarks) return;
  state.bookmark = bookmarks;
}
init();
